import { ProductEntity } from '../product.entity';
import { createEntityState, GenericEntityStateClass } from '../../core/state/entity.state';
import { Injectable } from '@angular/core';
import { EntityService } from '../../core/services/entity.service';

export const STATE_NAME = 'productEntity';

export const ProductEntityState: GenericEntityStateClass<ProductEntity> =
  createEntityState<ProductEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class ProductEntityService extends EntityService<ProductEntity> {
  constructor() {
    super();
    this.resourceType = 'products';
    this.stateClass = ProductEntityState;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): ProductEntity[] => {
      const slice = storeState[sliceName];
      return stateClass.allByQuery(slice, { query });
    };
  }
}
